import React, { useState } from "react";
import { auth } from "../firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SignIn() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // ✅ Single sign-in call
      await signInWithEmailAndPassword(auth, email, password);

      // ✅ Let AuthContext handle user state
      navigate("/");

    } catch (err) {
      setError(t("signin.error"));
    }
  };


const handleForgotPassword = async () => {
  if (!email) {
    alert("Please enter your email first");
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset email sent");
  } catch (err) {
    console.error(err);
    alert("Failed to send reset email");
  }
};


  return (
    <div className="edit-profile">
      <h2>{t("signin.title")}</h2>

      <form onSubmit={handleSignIn}>
        <input
          type="email"
          placeholder={t("signin.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="profile-input"
        />

        <input
          type="password"
          placeholder={t("signin.password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="profile-input"
        />

        <button type="submit" className="profile-save-btn">
          {t("signin.button")}
        </button>
      </form>

      {error && <p style={{ color: "red", marginTop: 10 }}>{error}</p>}

   <p
    style={{ marginTop: 10, color: "#2462eb", cursor: "pointer" }}
    onClick={handleForgotPassword}
   >
     {t("foorgot_password")}
   </p>



      <p style={{ marginTop: 12 }}>
        {t("signin.noAccount")}{" "}
        <span
          style={{ color: "#2462eb", cursor: "pointer" }}
          onClick={() => (window.location.href = "/signup")}
        >
          {t("signin.register")}
        </span>
      </p>
    </div>
  );
}
